import DialogComponent from "components/Dialog";

export default class AddPaymentWayToClinic extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            currentPaymentWay: false
        };

        this.state = {
            ...this.defaultState
        };
    }

    show(info, hideCb) {
        this.dialogTitle = `Добавить способ оплаты для клиники ${info.currentClinic}`;
        this.info = info;
        this.hidCb = hideCb;
        super.show();
    }

    save() {
        const { currentPaymentWay } = this.state;

        const info = {
            paymentWayId: currentPaymentWay
        };

        if (this.hidCb?.apply)
            this.hidCb(info);

        this.hide();
    }

    renderContent() {
        const { paymentWays } = this.info;
        return (
            <div className="content flex col gap24">
                {this.insertSelect({
                    label: "Способы оплат",
                    placeHolder: "Выберите способ оплаты",
                    showLeftIcon: false,
                    items: paymentWays,
                    onChange: this.changeState.bind(this, "currentPaymentWay")
                })}
            </div>
        );
    }
}

